import { Button, InputAdornment, TextField } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import { useContext, useState } from "react";
import GenericModal from "../Modal/GenericModal";
import { urlEnum } from "../Utils/urlEnum";
import { TemplatesType } from "../Utils/Constants";
import { VehicleContext } from "../Context/vehicleContext";
import moment from "moment";
import ArticleIcon from "@mui/icons-material/Article";
import { download } from "../Utils/utils";

export default function VehicleOfferButton() {
  const [openModal, setOpenModal] = useState(false);
  const [sellPriceNet, setSellPriceNet] = useState(0);
  const vehicleContext: any = useContext(VehicleContext);

  async function generateOfferDoc() {
    //enable loading
    let element = document.getElementById("loading");
    element?.classList.remove("loadingDisabled");
    element?.classList.add("loading");

    const url = `${urlEnum.templates}/${TemplatesType[5].name}`;
    const token = localStorage.getItem("access_token");

    const body = {
      vehicleId: vehicleContext?.state?.vehicle?.id,
      vehicle: vehicleContext.state.vehicle,
      siteLink: window.location.origin,
      price: sellPriceNet,
    };
    const fileName = `${moment().unix()}_Oferta_${
      vehicleContext?.state?.vehicle?.vin
    }.docx`;
    fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((response) => response.blob())
      .then((blob) => {
        download(
          blob,
          fileName,
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );
        //disable loading
        element = document.getElementById("loading");
        element?.classList.remove("loading");
        element?.classList.add("loadingDisabled");
      });
  }

  /**
   *
   */
  return (
    <div style={{ marginTop: "1rem" }}>
      <Button
        variant="contained"
        color="secondary"
        fullWidth
        style={{ color: "white" }}
        onClick={() => setOpenModal(true)}
      >
        {Vocabulary.generateVehicleOffer}
      </Button>
      <GenericModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title={Vocabulary.generateVehicleOffer}
      >
        <TextField
          type="number"
          value={sellPriceNet}
          fullWidth
          label={Vocabulary.sellPriceNet }
          onChange={(event) => setSellPriceNet(parseFloat(event.target.value))}
          style={{ marginTop: 10 }}
          InputProps={{
            endAdornment: <InputAdornment position="end">EURO</InputAdornment>,
          }}
        />
        {sellPriceNet > 0 && (
          <Button
            variant="contained"
            fullWidth
            style={{ marginTop: 20 }}
            color="secondary"
            startIcon={<ArticleIcon />}
            onClick={generateOfferDoc}
          >
            {Vocabulary.generateVehicleOffer}
          </Button>
        )}
      </GenericModal>
    </div>
  );
}
